module.exports = __webpack_public_path__ + "static/media/Abraço na alma.207818bb.jpg";